import { styled } from '@mui/material/styles';
import { Stack } from '@monorepo/nova-ui';

export const CartContentBox = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: 2,
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    marginBottom: '20px',
  },
}));

export const CartMainContentBox = styled(Stack)(({ theme }) => ({
  gap: [0, 42],
  width: '100%',
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(3.25), // 26px desktop
  },
}));
